// material ui
import { Theme } from '@mui/material';

export const drawerCustomization = {
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }: { theme: Theme }) => ({
        backgroundColor:
          theme.palette.mode === 'light'
            ? theme.palette.grey[50]
            : theme.palette.grey[900],
        backgroundImage: 'none',
      }),
    },
  },
};
